import APIService from "../api.service";

class UploadService {
  public async upload(data: any): Promise<any> {
    return APIService.post<any>(`/upload/public`, data);
  }
}

export default new UploadService();
